/*@ngInject*/
const AccountMediator = function (assignAccountRepository, createAccountRepository, getAccountRepository, getAccountsByFilterUriRepository, validateAccountRepository, formUpgradeCheckRepository, formUpgradeRepository) {

    this.assignAccount = function (submissionId, accountId, accountNumber) {
        return assignAccountRepository.assignAccount(submissionId, accountId, accountNumber);
    };

    this.createAccount = function (submissionId) {
        return createAccountRepository.createAccount(submissionId);
    };

    this.getAccountById = function (accountId) {
        return getAccountRepository.getAccountById(accountId);
    };

    this.getAccountsByFilterUri = function (filterUri, requestParams) {
        return getAccountsByFilterUriRepository.getAccountsByFilterUri(filterUri, requestParams);
    };

    this.validateAccount = function (accountId) {
        return validateAccountRepository.validateAccount(accountId);
    };

    this.formNeedsUpgrade = function (accountId) {
        return formUpgradeCheckRepository.accountFormsNeedsUpgrade(accountId);
    };

    this.upgradeForms = function (accountId) {
        return formUpgradeRepository.upgradeAccountForms(accountId);
    };

    this.synchronizeAccount = function (accountId) {
        return getAccountRepository.synchronizeAccount(accountId);
    };

};

angular.module('gw-um-submission').service('accountMediator', AccountMediator);
